import { FC } from 'react'
import { Modal } from 'antd'
import Button from '@UI/New/Button'
import Select from '@UI/New/Select'
import classes from '../index.module.css'
import type { TelephonyCallModalState } from '../phoneIntegrationButtons.types'

type TelephonyCallModalProps = {
  state: TelephonyCallModalState
  phoneNumber?: string
  callLoading: boolean
  onChange: (next: TelephonyCallModalState) => void
  onClose: () => void
  onCall: () => void
}

const TelephonyCallModal: FC<TelephonyCallModalProps> = ({
  state,
  phoneNumber,
  callLoading,
  onChange,
  onClose,
  onCall,
}) => (
  <Modal
    open={Boolean(state.endpoint)}
    onCancel={onClose}
    footer={null}
    title={`Звонок через ${state.endpoint?.name ?? 'телефонию'}`}
    centered
  >
    <div className={classes.callModalContent}>
      <Select
        fields={{
          value: state.extension || undefined,
          placeholder: 'Выберите внутренний номер',
          options: (state.endpoint?.outgoing_users ?? []).map((user) => ({
            value: user.extension,
            label: `${user.name} (${user.extension})`,
          })),
          onChange: (extension: string) =>
            onChange({ ...state, extension }),
        }}
      />
      {(state.endpoint?.outgoing_lines?.length ?? 0) > 1 ? (
        <Select
          fields={{
            value: state.lineNumber || undefined,
            placeholder: 'Выберите исходящий номер',
            options: (state.endpoint?.outgoing_lines ?? []).map((line) => ({
              value: line.number,
              label: line.name
                ? `${line.name} — ${line.number}`
                : line.number,
            })),
            onChange: (lineNumber: string) =>
              onChange({ ...state, lineNumber }),
          }}
        />
      ) : null}
      <Button
        disabled={!state.extension}
        isLoading={callLoading}
        onClick={onCall}
      >
        Позвонить на {phoneNumber}
      </Button>
    </div>
  </Modal>
)

export default TelephonyCallModal
